import { createSignal } from "solid-js";

import "~/components/shared/SEOBlock.css";
import "./SEOFront.css";

import IconExpandMore from "~/img/icons/expand_more.svg";

export default function SEOFront() {
  const [isExpanded, setIsExpanded] = createSignal(false);
  return (
    <>
      <section class="seo-front seo-block" data-test="block-seo">
        <div class="content-part">
          <div
            class="seo-text"
            classList={{ expanded: isExpanded() }}
            data-test="seo-text"
          >
            <div class="inner">
              <div class="text">
                <h2 class="no-margin-top">
                  Réalisez votre projet immobilier neuf avec un expert de
                  confiance
                </h2>
                <p>
                  Vous souhaitez devenir propriétaire de votre résidence
                  principale ou réaliser un{" "}
                  <strong>investissement immobilier</strong>&nbsp;? Votre
                  recherche de logement neuf mérite un accompagnement à la
                  hauteur de vos attentes.
                </p>
                <p>
                  Avec plus de 60 ans d’expertise dans la{" "}
                  <strong>promotion immobilière</strong>, Cogedim vous guide
                  dans la réalisation de votre{" "}
                  <strong>projet immobilier</strong>. Nos équipes vous
                  accompagnent à chaque étape, de la définition de vos besoins
                  jusqu’à la remise des clés de votre logement neuf.
                </p>
                <p>
                  Nos <strong>programmes immobiliers</strong> neufs, implantés
                  dans les villes les plus dynamiques de France, répondent à
                  toutes vos exigences&nbsp;: emplacement privilégié,
                  prestations de qualité, normes environnementales. Du studio au
                  5 pièces, découvrez des biens conçus pour votre confort et
                  valorisés dans le temps.
                </p>
                <h2>Un accompagnement sur-mesure pour votre achat</h2>
                <p>
                  La réussite de votre <strong>achat immobilier</strong> repose
                  sur un accompagnement personnalisé à chaque étape. Nos
                  conseillers experts étudient votre situation et définissent
                  avec vous le <strong>projet</strong> qui correspond à vos
                  objectifs&nbsp;: devenir propriétaire de votre résidence
                  principale ou constituer votre{" "}
                  <strong>patrimoine immobilier</strong>.
                </p>
                <p>
                  Des experts dédiés vous guident dans le choix de votre{" "}
                  <strong>futur logement</strong> et la personnalisation de ses
                  prestations. Nos équipes financières vous orientent vers les
                  meilleures solutions de financement et dispositifs fiscaux
                  adaptés à votre profil d’<strong>investisseur</strong>. De la
                  signature à la remise des clés, un interlocuteur unique suit
                  l’avancement de votre projet et répond à toutes vos questions.
                </p>
                <h2>Des programmes neufs partout en France</h2>
                <p>
                  Notre maillage national vous ouvre les portes des{" "}
                  <strong>grandes villes françaises</strong> les plus
                  attractives. Du Nord au Sud, de la{" "}
                  <strong>Provence-Alpes</strong> aux{" "}
                  <strong>Pays de la Loire</strong>, nos résidences s’implantent
                  au cœur des zones en développement où le{" "}
                  <strong>marché de l’immobilier</strong> est porteur.
                </p>
                <p>
                  Présents partout en France, nous sélectionnons rigoureusement
                  les emplacements de nos programmes pour leur potentiel et leur
                  qualité de vie. Chaque nouvelle résidence bénéficie de
                  l’expertise de nos <strong>promoteurs immobiliers</strong> et
                  de nos architectes, garantissant des réalisations pérennes qui
                  répondent aux attentes des propriétaires comme des
                  investisseurs.
                </p>
                <p>
                  Que vous recherchiez un appartement près de la capitale ou une
                  maison en région, nos équipes locales vous font découvrir les
                  opportunités de votre territoire et vous conseillent sur les
                  <strong> aides financières</strong>&nbsp;adaptés à votre
                  situation.
                </p>
                <h2>Financement de votre projet immobilier</h2>
                <p>
                  Le financement représente une étape déterminante dans
                  l’acquisition de votre logement neuf. Notre structure Altarea
                  Solution Financement vous accompagne vers la meilleure
                  stratégie en fonction de votre profil. Vous bénéficiez
                  d’accords privilégiés avec les principaux établissements
                  bancaires et d’une expertise approfondie des dispositifs
                  d’aide.
                </p>
                <p>
                  Un conseiller dédié analyse votre situation et construit avec
                  vous un plan de financement optimal. Du{" "}
                  <strong>prêt à taux zéro</strong> au{" "}
                  <strong>prêt accession sociale</strong>, en passant par les
                  solutions de <strong>crédit immobilier</strong> classiques,
                  nous vous guidons vers les montages financiers les plus
                  avantageux.
                </p>
                <p>
                  Grâce à notre service de courtage intégré, vous accédez à des
                  taux négociés et un suivi personnalisé de A à Z, du montage de
                  votre dossier jusqu’à la signature chez le notaire.
                </p>
                <h2>Investissement locatif&nbsp;: nos solutions</h2>
                <p>
                  L’investissement dans le neuf représente une stratégie
                  patrimoniale privilégiée par de nombreux Français. Pour
                  sécuriser votre placement, nos équipes spécialisées vous
                  accompagnent dans le choix du dispositif adapté à votre
                  profil&nbsp;: statut LMNP, nue-propriété ou investissement
                  classique.
                </p>
                <p>
                  La réussite d’un projet locatif repose sur un emplacement
                  stratégique et une gestion optimisée. Nos{" "}
                  <strong>programmes immobiliers</strong> sont sélectionnés dans
                  des zones à fort potentiel locatif, avec des{" "}
                  <strong>frais de notaire</strong> réduits et des garanties
                  exclusives. Faites le choix de sécuriser votre investissement,
                  grâce à Altarea Gestion Immobilière, vous bénéficiez d’une
                  gestion clé en main de votre bien.
                </p>
                <p>
                  Notre expertise du <strong>marché de l’immobilier</strong>{" "}
                  vous permet d’anticiper les évolutions et de constituer un
                  patrimoine pérenne. Des Hauts-de-France à la région Alpes-Côte
                  d’Azur, nos conseillers analysent avec vous les meilleures
                  opportunités d’investissement pour conjuguer rentabilité et
                  tranquillité.
                </p>
                <h2>Un promoteur expert depuis plus de 60 ans</h2>
                <p>
                  Avec plus de 120 000 logements réalisés depuis 1963, Cogedim
                  s’impose comme un acteur majeur des{" "}
                  <strong>métiers de l’immobilier</strong> en France. Notre
                  expertise s’est construite sur des valeurs d’excellence qui
                  perdurent&nbsp;: qualité architecturale, innovation permanente
                  et engagement environnemental.
                </p>
                <p>
                  Notre savoir-faire dans l’
                  <strong>investissement locatif</strong> se traduit par des
                  réalisations emblématiques, comme la création d’écoquartiers
                  nouvelle génération à Issy-les-Moulineaux, Toulouse ou encore
                  Rouen.
                </p>
              </div>
            </div>
            <div class="expand-button">
              <button
                type="button"
                onClick={() => setIsExpanded(!isExpanded())}
                aria-label="Découvrir comment faire un achat immobilier dans le neuf"
                data-test="btn-expand-seo"
              >
                <i aria-hidden="true" class="cog-icon">
                  <IconExpandMore />
                </i>
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
